<template>
  <font-awesome-icon
    icon="home"
    class="fa" />
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHome } from '@fortawesome/free-solid-svg-icons'

library.add(faHome)

export default {
  name: 'CoozzyHomeIcon'
}
</script>

<style lang="scss" scoped>
  .fa {
    color: $color-grey-dark;
  }
</style>
